var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import DealListQuery, { getDealList } from "@irati/deals/apollo/query/DealList";
import authentication from "@irati/auth";
import { getBlacklistedDeals, updateBlacklistedDeals } from "@irati/permissions/services/packages";
import addOrRemoveFromArray from "@irati/utils/addOrRemoveFromArray";
import { DealStatus } from "@irati/types";
import DealListItem from "./DealListItem";
import ListWrapper from "./styled/ListWrapper";
import LoadMore from "../../CompanyBenefitsList/LoadMore";
var DealList = /** @class */ (function (_super) {
    __extends(DealList, _super);
    function DealList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            blacklistedDeals: [],
            variables: {
                limit: 10,
                statuses: [DealStatus.On],
                ignoreBlacklist: true
            }
        };
        _this.handleToggle = function (uuid) {
            var newBlacklistedDeals = addOrRemoveFromArray(_this.state.blacklistedDeals, uuid);
            var tenant = authentication.userTenant();
            return updateBlacklistedDeals({ tenant: tenant }, newBlacklistedDeals).then(function (blacklist) {
                _this.props.onSave();
                _this.setState({ blacklistedDeals: blacklist });
            });
        };
        _this.isDealBlackListed = function (uuid) {
            return !!_this.state.blacklistedDeals.find(function (blacklistedDealUuid) { return blacklistedDealUuid === uuid; });
        };
        _this.handleNewPage = function (isVisible, apollo) {
            if (isVisible) {
                var _a = getDealList(apollo), results = _a.results, count = _a.count;
                var variables = _this.state.variables;
                var resultsLength = (results === null || results === void 0 ? void 0 : results.length) || 0;
                if (resultsLength && resultsLength !== count) { // has more
                    return apollo.nextPage(__assign(__assign({}, variables), { offset: resultsLength }));
                }
            }
        };
        return _this;
    }
    DealList.prototype.componentDidMount = function () {
        var _this = this;
        var tagId = this.props.tagId;
        var variables = this.state.variables;
        var tenant = authentication.userTenant();
        getBlacklistedDeals({ tenant: tenant }).then(function (blacklistedDeals) {
            if (blacklistedDeals === void 0) { blacklistedDeals = []; }
            _this.setState({
                blacklistedDeals: blacklistedDeals,
                variables: __assign(__assign({}, variables), { tags: [tagId], hideEB: true, hidePerksGo: true })
            });
        });
    };
    DealList.prototype.render = function () {
        var _this = this;
        return (React.createElement(ListWrapper, null,
            React.createElement(DealListQuery, { variables: this.state.variables }, function (apollo) {
                var dealsList = getDealList(apollo);
                return (React.createElement(React.Fragment, null,
                    dealsList.results.map(function (deal) { return (React.createElement(DealListItem, { key: deal.uuid, deal: deal, blacklisted: _this.isDealBlackListed(deal.uuid), handleToggle: _this.handleToggle })); }),
                    React.createElement(LoadMore, { onVisible: function (isVisible) { return _this.handleNewPage(isVisible, apollo); } })));
            })));
    };
    DealList.defaultProps = {
        tagId: null
    };
    return DealList;
}(Component));
export default DealList;
